import React from 'react';

import PropTypes from 'prop-types';

import { Paragraph9 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledTagSquare } from './styles';

const b = bemClassName('tag-square');

const formatTagText = (tag) => (tag ? tag.replace(/-/g, ' ') : '');

const TagSquare = ({ text, onClick, clickable = false }) => {
  return (
    <StyledTagSquare $clickable={clickable} onClick={onClick}>
      <span className={b()}>
        <Paragraph9>{formatTagText(text)}</Paragraph9>
      </span>
    </StyledTagSquare>
  );
};

TagSquare.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
};

export default TagSquare;
